module.exports = __webpack_public_path__ + "img/1_014.a6893c70.jpg";